<template>
  <div class="carousel">
    <div class="carousel--main" @mouseenter="mouseEnterWithoutId" @mouseleave="mouseLeave">
      <div class="carousel--bg">
        <template v-for="(post, index) in posts">
          <a :key="post.id" :href="post.href" :class="index === currentPost ? 'show' : 'hidden'"><img :src="`https://www.its-silver.com${post.thumb}`" alt=""/></a>
        </template>
      </div>
      <div class="carousel--desc" :class="{ 'carousel--desc_hidden': currentPost !== index }" v-for="(post, index) in posts" :key="post.id">
        <div class="wrapper" :class="carouselStatus(index)">
          <h1 class="title">
            <a :href="post.href">{{ post.title || '' }}</a>
          </h1>
          <div class="ab-positioned">
            <p class="desc">
              category: <a :href="post.cateHref">{{ post.cate || '' }}</a>
            </p>
            <BaseButton :link="post.href" iconclass="fal fa-chevron-right" color="#e94e77" background="white" style="border: 1px dashed #e94e77;">Read More</BaseButton>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel--aside">
      <div class="carousel--item" v-for="(post, index) in posts" :key="post.id">
        <div class="wrapper" :class="currentPost === index ? 'hover' : ''" @mouseenter="mouseEnter(post.id)" @mouseleave="mouseLeave">
          <time :datetime="post.date">{{ getDate(post) }}</time>
          <a class="title" :href="post.href">{{ post.title }}</a>
          <a class="desc" :href="post.cateHref">{{ post.cate }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clearTimeout, setTimeout, setInterval, clearInterval } from 'timers'
export default {
  props: {
    posts: {
      type: Array,
      default: function() {
        return [
          {
            title: '',
            cate: '',
            href: '',
            cateHref: ''
          }
        ]
      }
    }
  },
  data() {
    return {
      currentPost: 0,
      /* 鼠标移入时间 */
      timer: null,
      delay: 100,
      /* 记录desc状态 */
      loopDelay: 6000,
      /* 记录轮播setInterval */
      intervalTimer: null
    }
  },
  mounted() {
    this.loop()
  },
  methods: {
    getDate(post) {
      const date = post.date || new Date()
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    /* mouseenter */
    mouseEnter(id) {
      this.timer = setTimeout(() => {
        this.currentPost = id
      }, this.delay)
      /* 清除掉interval */
      clearInterval(this.intervalTimer)
    },
    mouseEnterWithoutId() {
      clearInterval(this.intervalTimer)
    },
    /* mouseleave */
    mouseLeave() {
      this.loop()
      clearTimeout(this.timer)
    },
    carouselStatus(index) {
      return this.currentPost === index ? 'carousel--wrap_show' : 'carousel--wrap_hidden'
    },
    /* 图片轮播 */
    loop() {
      this.intervalTimer = setInterval(() => {
        this.increaseIndex()
      }, this.loopDelay)
    },
    increaseIndex() {
      this.currentPost = (this.currentPost + 1) % this.posts.length
    },
    decreaseIndex() {
      this.currentPost = this.currentPost - 1 < 0 ? this.posts.length : this.currentPost
      this.currentPost -= 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/responsive.scss';
$max-line-number: 3;
$small-text-color: #86a8e7;
$text-color: #2c5364;
$text-hover-color: #434343;
$text-underline-color: #2c5364;
$dash-border-color: #b12a5b;

$box-shadow-color: #e2d1c3;
$background-hover-color: #fdfdfb;

$desc-transition: 0.5s ease-in;
$desc-max-height: 15em;
$image-border-radius: 10px;
$aside-border-radius: 5px;
$liner-gradient: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);

$margin: 80px;
$height: 580px;
@mixin shadow {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3), 5px 5px 15px rgba(0, 0, 0, 0.1), 5px 5px 20px rgba(0, 0, 0, 0.05);
}

.carousel {
  display: flex;
  justify-content: space-around;
  margin-bottom: 50px;
  .show {
    display: block;
  }
  .hidden {
    display: none;
  }
  .carousel--main {
    // height: 400px;
    align-self: center;
    margin-top: $margin;
    // margin-right: $margin;
    margin-bottom: $desc-max-height;
    border-radius: $image-border-radius;
    flex: 0 850px;
    position: relative;
    font-size: 12px;
    // padding: 5px;
    align-self: flex-end;
    &:hover {
      cursor: pointer;
    }
    .title,
    .desc {
      margin: 1em 0;
      text-transform: uppercase;
    }
    .title {
      font-size: 1.5em;
      font-weight: bolder;
      font-style: italic;

      a {
        text-decoration: none;
        color: white;
        border-bottom: 1px dashed $text-underline-color;
      }
    }

    .carousel--bg {
      @include shadow();
      position: absolute;
      max-height: 470px;
      width: 100%;
      overflow: hidden;
      bottom: 100%;
      display: flex;
      justify-content: stretch;
      align-items: center;
      a {
        flex: 1 1;
        img {
          transition: 0.3s;

          // object-fit: contain;
          width: 100%;
          &:hover {
            transform: scale(1.05);
          }
        }
      }
      // &::before {
      //   position: absolute;
      //   display: block;
      //   content: '';
      //   left: -2px;
      //   right: -2px;
      //   top: -2px;
      //   bottom: -2px;
      //   background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
      // }
    }
    .carousel--desc {
      $margin-top: 10px;
      margin-top: $margin-top;
      color: white;
      position: absolute;
      top: 100%;
      left: 0px;
      right: 0px;
      padding: 1em 10vw 2em 1.5em;
      background-image: linear-gradient(to right, #ff8177 0%, #ff867a 0%, #ff8c7f 21%, #f99185 52%, #cf556c 78%, #b12a5b 100%);
      overflow: hidden;
      transition: 0.3s;
      opacity: 1;
      filter: brightness(1);
      max-height: calc(#{$desc-max-height} - #{$margin-top});
      // clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 65% 75%, 0% 75%);
      .desc a {
        color: white;
      }
      a {
        display: inline-block;

        transition: 0.3s;
      }
      a:hover {
        transform: translate(5px);

        color: #7e374a;
      }
      // .ab-positioned {
      //   position: absolute;
      //   top: 100%;
      //   left: 0;
      //   right: 0;
      // }
    }
    .carousel--desc_hidden {
      opacity: 0;
      pointer-events: none;
    }
    .carousel--wrap_show {
      opacity: 1;
      transform: translate(0);
      transition: 0.3s ease-in;
    }
    .carousel--wrap_hidden {
      pointer-events: none;
      transition: $desc-transition;
      opacity: 0;
      transform: translateX(20px);
    }
  }
  .carousel--aside {
    height: 670px;
    @include shadow;
    background: $liner-gradient;
    overflow: hidden;
    flex: 0 1 250px;
    padding-top: 1em;
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    // border-radius: $aside-border-radius;
    // border: 1px dashed $dash-border-color;
    time {
      font-size: 12px;
      color: $small-text-color;
    }
    a {
      cursor: pointer;
      display: block;
      &.title {
        font-size: 14px;
        margin: 0.4em 0;
        color: $text-color;
        text-decoration: none;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: $max-line-number;
        -webkit-box-orient: vertical;
        &:hover {
          color: $text-hover-color;
          text-decoration: $text-underline-color underline;
        }
      }
      &.desc {
        font-size: 12px;
        font-weight: bold;
        color: $small-text-color;
        &:hover {
          color: $text-hover-color;
          text-decoration: $text-underline-color underline;
        }
      }
    }

    .carousel--item {
      flex: 1;
      display: flex;
      overflow: hidden;
      .wrapper {
        // border-radius: 8px;
        flex: 1 1;
        overflow: hidden;
        margin: 0 1em 1em;
        padding: 0em 0.5em;
        transition: 0.1s ease-in;
        // border: 1px solid transparent;
      }
      .hover {
        cursor: pointer;
        background: $background-hover-color;
        box-shadow: 0px 0px 4px $box-shadow-color;
        // border: 0px solid $box-shadow-color !important;
      }
      &:not(:first-child) .wrapper {
        border-top: 1px dashed $dash-border-color;
      }
      &:first-child .wrapper {
        border-top: 1px dashed $dash-border-color;
      }
    }
  }
}

@media screen and (max-width: $screen-lg) {
  .carousel {
    .carousel--main {
      margin-right: 40px;
      flex: 1 1;
    }
    .carousel--aside {
      flex: 0 0 230px;
    }
  }
}
@media screen and (max-width: $screen-md) {
  .carousel {
    display: block;
    margin-bottom: 725px;
    position: relative;
    .carousel--main {
      position: absolute;
      // opacity: 0;
      top: 100%;
      width: 100%;
      order: 1;
      margin-right: 0;
      margin-left: 0;
      bottom: none;
      .carousel--bg {
        position: static;
        width: 100%;
        height: fit-content;
      }
      .carousel--desc {
        top: 100%;
        bottom: unset;
        padding: 1em 2em 1.5em;
      }
    }
    .carousel--aside {
      height: auto;
      order: 0;
      flex: 1 1;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 10px;
      overflow: hidden;
      .carousel--item {
        flex: 1 1 33%;
      }
    }
  }
}
@media screen and (max-width: $screen-sm) {
  .carousel {
    margin-bottom: calc(80vw + 220px);
    .carousel--main .carousel--desc {
      font-size: 8px;
    }
    .carousel--aside {
      display: flex;
      flex-direction: column;
      .carousel--item {
        flex: 1 1;
      }
    }
  }
}
</style>
